import { render, staticRenderFns } from "./ProductAddForm.vue?vue&type=template&id=3aa6986d&scoped=true"
import script from "./ProductAddForm.vue?vue&type=script&lang=js"
export * from "./ProductAddForm.vue?vue&type=script&lang=js"
import style0 from "./ProductAddForm.vue?vue&type=style&index=0&id=3aa6986d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa6986d",
  null
  
)

export default component.exports